export const LoginTypes = {
  RQ_LOGIN: 'RQ_LOGIN',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_ERROR: 'LOGIN_ERROR',
  ADMIN_LOGIN: 'ADMIN_LOGIN',
  LOGIN_BUTTON: 'LOGIN_BUTTON',
  LICENSE_ERROR: 'LICENSE_ERROR',
}
